import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import StyledInput from "../../../../components/styledInput/StyledInput";
import React, { useEffect, useMemo, useState } from "react";
import ApiDatabase from "../../../../server";

const ModalCreateSectorSettings = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const [name, setName] = useState("");
  const [userIds, setUserIds] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const employees = modalData?.employees || [];
  const onSuccess = modalData?.onSuccess;

  useEffect(() => {
    setName("");
    setUserIds([]);
    setError("");
    setSubmitting(false);
  }, [modalData]);

  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const handleSubmit = () => {
    if (!canSubmit) return;
    setSubmitting(true);
    setError("");
    ApiDatabase.postCreateSector(
      { name: name.trim(), userIds },
      () => {
        setSubmitting(false);
        if (onSuccess) onSuccess();
        toggle();
      },
      (err) => {
        setSubmitting(false);
        setError(
          err?.response?.data?.message ||
            "Impossible de créer ce secteur."
        );
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Créer un secteur
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <p className="ft-sm text-gray-500">
            Le secteur peut être créé sans membres ; vous pourrez les ajouter
            ensuite depuis la liste.
          </p>
          <StyledInput
            type="text"
            label="Nom du secteur"
            placeholder="Nom du secteur"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <StyledInput
            label="Utilisateurs autorisés"
            type="selectMultipleCheckbox"
            isSearchable={true}
            value={`${userIds.length} ${
              userIds.length === 1 ? "membre" : "membres"
            }`}
            list={employees.map((employee) => ({
              value: employee._id,
              label: `${employee.firstname} ${employee.lastname}`.trim(),
              checked: userIds.some(
                (id) => String(id) === String(employee._id),
              ),
            }))}
            onChange={(updated) =>
              setUserIds(
                updated.filter((opt) => opt.checked).map((opt) => opt.value),
              )
            }
          />
          {error ? <div className="ft-sm text-red-600">{error}</div> : null}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="SECONDARY" size="LG" onClick={toggle}>
          Annuler
        </Button>
        <SubmitButton
          loading={submitting}
          disabled={!canSubmit}
          onClick={handleSubmit}
        />
      </ModalFooter>
    </>
  );
};

export default ModalCreateSectorSettings;
